import { Divider, Grid, Typography } from '@mui/material';
import React from 'react';
import styles from "../../../../../assets/styles/componentStyles/chatbotStyles/chats.module.scss";
import globalStyles from "../../../../../assets/styles/global.module.scss";

export interface SaveVariableActionProps {
    actionData: any,
}

const SaveVariableAction: React.FC<SaveVariableActionProps> = (props) => {
    
    const { actionData } = props;

    return (
        <>
            <Grid container className={`${styles.saveVariableActionMainContainer} ${globalStyles.flexColumn}`} gap={1}>
                <Grid item className={globalStyles.fullwidth}>
                    <Typography className={styles.customAPICallMsgTitle}>Variable Saved</Typography>
                </Grid>
                <Divider />
                <Grid item className={globalStyles.fullwidth}>
                    <Grid container gap={"4px"} flexWrap={"nowrap"} alignItems={"center"}>
                        <Grid item xs={4} className={styles.customAPICallInfoTitle}>
                            Variable    
                        </Grid> 
                        <Grid item xs={7.5}>
                            {actionData?.saved_variables?.chatbot_custom_variable_configuration_name || "-"}
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item className={globalStyles.fullwidth}>
                    <Grid container gap={"4px"} flexWrap={"nowrap"} alignItems={"center"}>
                        <Grid item xs={4} className={styles.customAPICallInfoTitle}>
                            Value    
                        </Grid> 
                        <Grid item xs={7.5}>
                            {actionData?.saved_variables?.variable_value || "-"}
                        </Grid>
                    </Grid>
                </Grid>

            </Grid>
        </>
    )
}

export default SaveVariableAction